import React, { useState, useEffect, useRef } from 'react';
import { walletAmount, WalletValue, useAuth } from '../context/AuthContext';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldCheck, Bomb, Gem, ArrowUpFromLine, ChevronLeft, ChevronRight, Infinity as InfinityIcon, Info, Square } from 'lucide-react';
import { toast } from 'sonner';
import { useChatLayout } from '../context/ChatLayoutContext';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
const API = `${BACKEND_URL}/api`;

// ==========================================
// K, M, B FORMATLAYICILARI (ÇİFT YÖNLÜ)
// ==========================================
const parseAmount = (valStr) => {
  if (!valStr) return 0;
  // ⚠️ BİNLİK AYIRICI TEMİZLENMELİ. formatAmount() büyük sayıları
  // toLocaleString ile üretiyor ("1,457,545"); parseFloat virgülde durup
  // 1 döndürüyordu. MAX butonuna basan kullanıcı 1 birim bahis oynuyordu.
  let str = valStr.toString().trim().toLowerCase().replace(/[,\s]/g, '');
  let multiplier = 1;
  if (str.endsWith('k')) { multiplier = 1000; str = str.slice(0, -1); }
  else if (str.endsWith('m')) { multiplier = 1000000; str = str.slice(0, -1); }
  else if (str.endsWith('b')) { multiplier = 1000000000; str = str.slice(0, -1); }

  const parsedValue = parseFloat(str);
  return isNaN(parsedValue) ? 0 : Math.floor(parsedValue * multiplier);
};

const formatAmount = (amount) => {
  if (amount === undefined || amount === null || amount === 0) return '';
  const sign = amount < 0 ? '-' : '';
  const abs = Math.abs(amount);
  if (abs >= 1000000) return sign + abs.toLocaleString();
  if (abs >= 1000) return sign + parseFloat((abs / 1000).toFixed(2)) + 'K';
  return sign + abs.toString();
};

// Küçük bekleme yardımcısı (auto-bet animasyon temposu için)
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

// ⚡ SABİT ANİMASYON NESNELERİ. Satır içi `{ scale: 1.05 }` her render'da
// YENİ nesne üretiyor; framer 25 kutunun prop'larını değişmiş sayıp
// hepsini yeniden değerlendiriyordu.
const HOVER_SCALE = { scale: 1.05 };
const TAP_SCALE = { scale: 0.95 };
const EMPTY_ANIM = {};

export const Mines = () => {
  const { user, token, isAuthenticated, balance, fmtMoney, wallet, betToRaw, rawToBet, betLimits } = useAuth();
  const [betAmount, setBetAmount] = useState('');
  // 💬 Aç/kapa durumu paylaşımlı: sayfa değişse de korunur.
  const { chatOpen } = useChatLayout();
  const [minesCount, setMinesCount] = useState(3);

  const [phase, setPhase] = useState('idle'); // idle, playing, cashed_out, crashed
  const [board, setBoard] = useState(Array(25).fill({ revealed: false, type: null, isPlayerChoice: false }));
  const [currentMultiplier, setCurrentMultiplier] = useState(1.00);
  const [nextMultiplier, setNextMultiplier] = useState(null);

  const [serverHash, setServerHash] = useState('');
  const [serverSeed, setServerSeed] = useState('');
  const [winAmount, setWinAmount] = useState(0);

  // ==========================================
  // YENİ: AUTO BET STATE'LERİ
  // ==========================================
  const [mode, setMode] = useState('manual');          // 'manual' | 'auto'
  const [autoTiles, setAutoTiles] = useState([]);       // seçilen kutu indeksleri (sırayla)
  const [numberOfBets, setNumberOfBets] = useState(''); // boş = sonsuz
  const [onWinAction, setOnWinAction] = useState('reset');   // 'reset' | 'increase'
  const [onWinPct, setOnWinPct] = useState('');
  const [onLossAction, setOnLossAction] = useState('reset'); // 'reset' | 'increase'
  const [onLossPct, setOnLossPct] = useState('');
  const [stopOnProfit, setStopOnProfit] = useState('');
  const [stopOnLoss, setStopOnLoss] = useState('');
  const [autoRunning, setAutoRunning] = useState(false);
  const [autoStats, setAutoStats] = useState({ bets: 0, profit: 0, wins: 0 });
  const [autoFlash, setAutoFlash] = useState(null);     // 'win' | 'lose' | null (son tur sonucu rengi)

  const autoRunningRef = useRef(false);

  // SES EFEKTLERİ
  const explosionSound = useRef(null);
  const successSound = useRef(null);

  useEffect(() => {
    if (typeof Audio !== "undefined") {
      explosionSound.current = new Audio('/explosion.mp3');
      successSound.current = new Audio('/towerWin.wav');
      explosionSound.current.volume = 0.8;
      successSound.current.volume = 0.5;
    }
  }, []);

  // Bileşen kapanırsa auto-bet'i güvenle durdur
  useEffect(() => () => { autoRunningRef.current = false; }, []);

  const playSound = (audioRef) => {
    if (audioRef.current) {
      audioRef.current.currentTime = 0;
      audioRef.current.play().catch(() => {});
    }
  };

  // K, M, B Destekli Hızlı Buton Fonksiyonları
  const handleBetChange = (val) => setBetAmount(val);

  const addBetAmount = (val) => {
    const current = parseAmount(betAmount);
    setBetAmount(String(current + val));
  };

  const multiplyBet = (mult) => {
    const current = parseAmount(betAmount);
    setBetAmount(String(Math.floor(current * mult)));
  };

  // ==========================================
  // MANUEL OYUN: BAŞLAT
  // ==========================================
  const startGame = async () => {
    // 🎯 Kullanıcı AKTİF CÜZDANIN biriminde yazar (Robux → site birimi,
    // BB Coin → BB). betToRaw saklama birimine çevirir: BB'de ×1000.
    // Bu satır olmadan "10" yazan oyuncu 10 mili-BB (0,01 BB) oynardı.
    const amount = betToRaw(parseAmount(betAmount));

    if (!isAuthenticated) return toast.error("Please log in first!");
    // ⚠️ Limitler cüzdana göre (site birimi gömülüydü).
    if (!amount || amount < betLimits.min_bet || amount > betLimits.max_bet) return toast.error(`Bet must be between ${walletAmount(betLimits.min_bet, wallet)} and ${walletAmount(betLimits.max_bet, wallet)}.`);

    try {
      const response = await axios.post(`${API}/game/mines/start`, {
        amount: amount,
        mines_count: minesCount
      }, { headers: { Authorization: `Bearer ${token}` } });

      setPhase('playing');
      setBoard(Array(25).fill({ revealed: false, type: null, isPlayerChoice: false }));
      setCurrentMultiplier(1.00);
      setNextMultiplier(null);
      setWinAmount(0);
      setServerHash(response.data.server_seed_hash);
      setServerSeed('');

    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to start game!");
    }
  };

  // ==========================================
  // MANUEL OYUN: KUTUYA TIKLA
  // ==========================================
  const handleTileClick = async (index) => {
    if (phase !== 'playing' || board[index].revealed) return;

    try {
      const response = await axios.post(`${API}/game/mines/click`, {
        tile_index: index
      }, { headers: { Authorization: `Bearer ${token}` } });

      const data = response.data;

      if (data.status === 'playing') {
        playSound(successSound);
        setBoard(prev => {
          const newBoard = [...prev];
          newBoard[index] = { revealed: true, type: 'diamond', isPlayerChoice: true };
          return newBoard;
        });
        setCurrentMultiplier(data.multiplier);
        setNextMultiplier(data.next_multiplier);
      }
      else if (data.status === 'crashed') {
        playSound(explosionSound);
        setPhase('crashed');
        setServerSeed(data.server_seed);
        revealBoard(data.board_map, index, 'bomb');
      }
      else if (data.status === 'cashed_out') {
        playSound(successSound);
        setPhase('cashed_out');
        setWinAmount(data.win_amount);
        setCurrentMultiplier(data.multiplier);
        setServerSeed(data.server_seed);
        revealBoard(data.board_map, index, 'diamond');
      }

    } catch (error) {
      toast.error(error.response?.data?.detail || "Error opening tile!");
    }
  };

  // ==========================================
  // MANUEL OYUN: ÇEKİL (CASHOUT)
  // ==========================================
  const handleCashout = async () => {
    if (phase !== 'playing' || currentMultiplier <= 1.00) return;

    try {
      const response = await axios.post(`${API}/game/mines/cashout`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const data = response.data;
      playSound(successSound);
      setPhase('cashed_out');
      setWinAmount(data.win_amount);
      setServerSeed(data.server_seed);
      revealBoard(data.board_map, null, null);

    } catch (error) {
      toast.error(error.response?.data?.detail || "Error cashing out!");
    }
  };

  // OYUN BİTİNCE TÜM HARİTAYI GÖSTER
  const revealBoard = (boardMap, clickedIndex, clickedType) => {
    setBoard(prev => {
      const newBoard = [...prev];
      boardMap.forEach((isBomb, idx) => {
        if (idx === clickedIndex) {
          newBoard[idx] = { revealed: true, type: clickedType, isPlayerChoice: true };
        } else if (!newBoard[idx].revealed) {
          newBoard[idx] = { revealed: true, type: isBomb ? 'bomb' : 'diamond', isPlayerChoice: false };
        }
      });
      return newBoard;
    });
  };

  // ==========================================
  // YENİ: AUTO BET YARDIMCILARI
  // ==========================================

  // Manuel/Auto sekmesi değiştir (oyun aktifken kilitli)
  const switchMode = (m) => {
    if (autoRunning || phase === 'playing') return;
    setMode(m);
    setPhase('idle');
    setBoard(Array(25).fill({ revealed: false, type: null, isPlayerChoice: false }));
    setCurrentMultiplier(1.00);
    setNextMultiplier(null);
    setAutoFlash(null);
  };

  // Auto modda kutu seç/kaldır
  const toggleAutoTile = (idx) => {
    setAutoTiles(prev => prev.includes(idx) ? prev.filter(i => i !== idx) : [...prev, idx]);
  };

  // Grid tıklaması: auto modda seçim, manuel modda oyun
  const onTileClick = (idx) => {
    if (mode === 'auto') {
      if (autoRunning) return;           // koşarken kilitli
      toggleAutoTile(idx);
      return;
    }
    handleTileClick(idx);
  };

  // Sadece rakam giriş yardımcıları
  const handleDigitsOnly = (setter) => (v) => setter(v.replace(/[^0-9]/g, ''));
  const handleDecimal = (setter) => (v) => setter(v.replace(/[^0-9.]/g, ''));

  const stopAutoBet = () => {
    autoRunningRef.current = false;
    setAutoRunning(false);
    toast("Autobet will stop after this round.");
  };

  // ==========================================
  // YENİ: AUTO BET ANA DÖNGÜSÜ
  // ==========================================
  const startAutoBet = async () => {
    const baseBet = parseAmount(betAmount);

    if (!isAuthenticated) return toast.error("Please log in first!");
    if (autoTiles.length === 0) return toast.error("Tap tiles on the grid to set your auto-pick pattern first!");
    if (!baseBet || baseBet < betLimits.min_bet || baseBet > betLimits.max_bet) return toast.error(`Bet must be between ${walletAmount(betLimits.min_bet, wallet)} and ${walletAmount(betLimits.max_bet, wallet)}.`);

    const nBets = numberOfBets ? parseInt(numberOfBets, 10) : 0;
    const profitTarget = parseAmount(stopOnProfit);
    const lossLimit = parseAmount(stopOnLoss);
    const winPct = parseFloat(onWinPct) || 0;
    const lossPct = parseFloat(onLossPct) || 0;

    autoRunningRef.current = true;
    setAutoRunning(true);
    setPhase('idle');
    setAutoFlash(null);
    setWinAmount(0);
    setAutoStats({ bets: 0, profit: 0, wins: 0 });

    let currentBet = baseBet;
    let betsLeft = nBets > 0 ? nBets : Infinity;
    let sessionProfit = 0;
    let betsPlayed = 0;
    let wins = 0;
    let stopMessage = null;

    try {
      while (autoRunningRef.current && betsLeft > 0) {
        // Bahsi limitlere kelepçele (1 - 100,000)
        currentBet = Math.max(10000, Math.min(1000000000, currentBet));

        // 1) TURU BAŞLAT
        try {
          const res = await axios.post(`${API}/game/mines/start`, {
            amount: currentBet, mines_count: minesCount
          }, { headers: { Authorization: `Bearer ${token}` } });
          setServerHash(res.data.server_seed_hash);
          setServerSeed('');
        } catch (err) {
          stopMessage = { type: 'error', text: err.response?.data?.detail || "Autobet stopped: couldn't start a round." };
          break;
        }

        // Yeni tur için tahtayı sıfırla, seçim deseni görünür kalsın
        setBoard(Array(25).fill({ revealed: false, type: null, isPlayerChoice: false }));
        setCurrentMultiplier(1.00);
        setNextMultiplier(null);
        setAutoFlash(null);
        await sleep(160);

        // 2) SEÇİLİ KUTULARI SIRAYLA AÇ (tur durdurmadan tamamlanır)
        let won = true;
        let gameActive = true;
        let roundWin = 0;
        let crashIndex = null;
        let revealMap = null;
        let revealClickType = null;

        for (const tileIdx of autoTiles) {
          let data;
          try {
            const res = await axios.post(`${API}/game/mines/click`, {
              tile_index: tileIdx
            }, { headers: { Authorization: `Bearer ${token}` } });
            data = res.data;
          } catch (err) {
            // Beklenmedik hata → turu kapat, döngüyü durdur
            won = false; gameActive = false;
            stopMessage = { type: 'error', text: err.response?.data?.detail || "Autobet stopped due to a round error." };
            autoRunningRef.current = false;
            break;
          }

          if (data.status === 'playing') {
            playSound(successSound);
            setBoard(prev => {
              const nb = [...prev];
              nb[tileIdx] = { revealed: true, type: 'diamond', isPlayerChoice: true };
              return nb;
            });
            setCurrentMultiplier(data.multiplier);
            setNextMultiplier(data.next_multiplier);
            await sleep(230);
          } else if (data.status === 'crashed') {
            playSound(explosionSound);
            won = false; gameActive = false;
            roundWin = 0;
            crashIndex = tileIdx;
            revealMap = data.board_map;
            revealClickType = 'bomb';
            setServerSeed(data.server_seed);
            break;
          } else if (data.status === 'cashed_out') {
            // Tüm güvenli kutular açıldı → otomatik cashout
            playSound(successSound);
            won = true; gameActive = false;
            roundWin = data.win_amount;
            setCurrentMultiplier(data.multiplier);
            setServerSeed(data.server_seed);
            revealMap = data.board_map;
            revealClickType = null;
            break;
          }
        }

        // 3) Oyun hâlâ açıksa ve patlamadıysak parayı çek
        if (won && gameActive) {
          try {
            const res = await axios.post(`${API}/game/mines/cashout`, {}, {
              headers: { Authorization: `Bearer ${token}` }
            });
            roundWin = res.data.win_amount;
            setCurrentMultiplier(res.data.multiplier);
            setServerSeed(res.data.server_seed);
            revealMap = res.data.board_map;
            revealClickType = null;
          } catch (err) {
            // Cashout başarısızsa bu turu kayıp sayma; bir sonraki tura geç
            won = false;
          }
        }

        // 4) Tüm tahtayı göster (görsel)
        if (revealMap) revealBoard(revealMap, crashIndex, revealClickType);

        // 5) Sonuç ve istatistik
        const roundProfit = won ? (roundWin - currentBet) : -currentBet;
        sessionProfit += roundProfit;
        betsPlayed++;
        if (won) { wins++; setWinAmount(roundWin); }
        setAutoFlash(won ? 'win' : 'lose');
        setAutoStats({ bets: betsPlayed, profit: sessionProfit, wins });

        // 6) Sonraki tur için bahis ayarı
        if (won) {
          currentBet = onWinAction === 'reset' ? baseBet : Math.floor(currentBet * (1 + winPct / 100));
        } else {
          currentBet = onLossAction === 'reset' ? baseBet : Math.floor(currentBet * (1 + lossPct / 100));
        }

        // 7) Durdurma koşulları
        if (profitTarget > 0 && sessionProfit >= profitTarget) {
          stopMessage = { type: 'success', text: `Profit target reached: +${walletAmount(sessionProfit, wallet)}` };
          break;
        }
        if (lossLimit > 0 && sessionProfit <= -lossLimit) {
          stopMessage = { type: 'error', text: `Loss limit reached: -${walletAmount(Math.abs(sessionProfit), wallet)}` };
          break;
        }

        betsLeft--;

        // Sonucu görebilmesi için turlar arası kısa duraklama
        if (autoRunningRef.current && betsLeft > 0) await sleep(950);
      }
    } finally {
      autoRunningRef.current = false;
      setAutoRunning(false);
    }

    if (stopMessage) {
      if (stopMessage.type === 'success') toast.success(stopMessage.text);
      else if (stopMessage.type === 'error') toast.error(stopMessage.text);
    }
  };

  // ==========================================
  // KUTU STİLİ
  // ==========================================
  const getTileStyle = (tile, idx) => {
    // Auto modda seçili ama henüz açılmamış kutu → mor hedef işareti
    if (!tile.revealed && mode === 'auto' && autoTiles.includes(idx)) {
      return "bg-[#B059E8]/15 border-[#B059E8] shadow-[0_0_18px_rgba(176,89,232,0.3)] cursor-pointer";
    }

    if (!tile.revealed) {
      if (mode === 'auto' && !autoRunning) {
        // Auto seçim modunda boş kutu → tıklanabilir
        return "bg-[#2A2D31]/40 border-[#2A2D31] hover:bg-[#33363b]/80 hover:border-[#B059E8]/50 cursor-pointer shadow-[0_0_15px_rgba(0,0,0,0.2)]";
      }
      return phase === 'playing'
        ? "bg-[#2A2D31]/40 border-[#2A2D31] hover:bg-[#33363b]/80 hover:border-[#B059E8]/50 cursor-pointer shadow-[0_0_15px_rgba(0,0,0,0.2)]"
        : "bg-[#15171a] border-[#2A2D31]/30 opacity-50";
    }

    if (tile.type === 'diamond') {
      return tile.isPlayerChoice
        ? "bg-[#16A34A]/20 border-[#16A34A] shadow-[0_0_20px_rgba(22,163,74,0.3)]"
        : "bg-[#16A34A]/10 border-[#16A34A]/30 opacity-40";
    }

    if (tile.type === 'bomb') {
      return tile.isPlayerChoice
        ? "bg-rose-500/20 border-rose-500 shadow-[0_0_20px_rgba(244,63,94,0.4)]"
        : "bg-rose-500/10 border-rose-500/30 opacity-40";
    }
  };

  // Çarpan rengi (auto modda son tur sonucuna göre)
  const multiplierColor = mode === 'auto'
    ? (autoFlash === 'lose' ? 'text-rose-500' : 'text-[#2ecf6e]')
    : (phase === 'crashed' ? 'text-rose-500' : 'text-[#2ecf6e]');

  // Ortak input kilidi (oyun ya da auto koşarken)
  const inputsLocked = autoRunning || phase === 'playing';
  const tabsLocked = autoRunning || phase === 'playing';

  return (
    <div className="min-h-screen bg-[#0E0F11]" data-testid="mines-page">
      <div className="max-w-[1800px] mx-auto px-4 pt-24 pb-8">
        <div className={`flex flex-col lg:flex-row gap-6 transition-[padding] duration-300 ${chatOpen ? 'md:pl-[340px] lg:pl-[370px]' : ''}`}>

          {/* 💬 Sohbet App.js'te TEK kopya render ediliyor (ChatDock).
              Sayfa-içi kopya kaldırıldı: her gezinmede WebSocket kopup
              yeniden bağlanıyor ve 4 HTTP isteği tekrar atılıyordu. */}
          <main className="flex-1 flex flex-col lg:flex-row gap-6 min-w-0 lg:h-[calc(100vh-120px)]">

            {/* SOL SÜTUN: KONTROLLER */}
            <div className="w-full lg:w-80 flex-shrink-0 flex flex-col gap-4 h-full">
              <div className="bg-[#1A1D20] rounded-2xl border border-[#2A2D31] p-4 shadow-lg h-full flex flex-col">

                {/* MANUAL / AUTO SEKMESİ */}
                <div className="flex bg-[#15171a] border border-[#2A2D31] rounded-xl p-1 gap-1 mb-4">
                  {['manual', 'auto'].map((m) => (
                    <button
                      key={m}
                      onClick={() => switchMode(m)}
                      disabled={tabsLocked}
                      className={`flex-1 py-2.5 rounded-lg text-sm font-bold capitalize transition-all disabled:cursor-not-allowed ${
                        mode === m
                          ? 'bg-gradient-to-r from-[#7b2fc4] to-[#B059E8] text-white shadow-[0_0_15px_rgba(176,89,232,0.35)]'
                          : 'text-zinc-400 hover:text-white disabled:opacity-50'
                      }`}
                    >
                      {m}
                    </button>
                  ))}
                </div>

                {/* KAYDIRILABİLİR İÇERİK */}
                <div className="space-y-4 flex-1 overflow-y-auto pr-1 -mr-1 mines-scroll">

                  {/* MAYIN SAYISI */}
                  <div>
                    <label className="flex items-center gap-2 text-xs text-zinc-400 font-bold mb-2">
                      <Bomb className="w-4 h-4" /> MINES COUNT
                    </label>
                    <div className="flex bg-[#15171a] border border-[#2A2D31] rounded-xl overflow-hidden focus-within:border-[#B059E8] transition-colors mb-2">
                      <input
                        type="number"
                        min="1"
                        max="24"
                        value={minesCount}
                        onChange={(e) => setMinesCount(Math.max(1, Math.min(24, parseInt(e.target.value) || 1)))}
                        disabled={inputsLocked}
                        className="w-full bg-transparent py-3 px-4 text-white font-bold outline-none disabled:opacity-50 text-center"
                      />
                    </div>
                    <div className="grid grid-cols-4 gap-2">
                      {[3, 5, 10, 24].map((num) => (
                        <button
                          key={num}
                          onClick={() => setMinesCount(num)}
                          disabled={inputsLocked}
                          className={`py-2 rounded-lg text-xs font-bold transition-all ${
                            minesCount === num
                              ? 'bg-rose-500 text-white shadow-[0_0_15px_rgba(244,63,94,0.4)]'
                              : 'bg-[#2A2D31]/50 text-zinc-400 hover:bg-[#33363b] hover:text-white disabled:opacity-50'
                          }`}
                        >
                          {num}
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* BAHİS MİKTARI */}
                  <div>
                    <label className="text-xs text-zinc-400 font-bold mb-1.5 block">
                      {mode === 'auto' ? 'Base Bet' : 'Bet Amount'}
                    </label>
                    <div className="flex bg-[#15171a] border border-[#2A2D31] rounded-xl overflow-hidden focus-within:border-[#B059E8] transition-colors">
                      <div className="pl-3 flex items-center justify-center">
                        <span className="text-zinc-500 font-bold">$</span>
                      </div>
                      <input
                        type="text"
                        value={betAmount}
                        onChange={(e) => handleBetChange(e.target.value)}
                        disabled={inputsLocked}
                        className="w-full bg-transparent py-3 px-2 text-white font-bold outline-none disabled:opacity-50 uppercase"
                        placeholder="1"
                      />
                      <div className="flex border-l border-[#2A2D31]">
                        <button onClick={() => addBetAmount(10)} disabled={inputsLocked} className="px-3 text-xs font-bold text-zinc-400 hover:text-white hover:bg-[#33363b] transition-colors border-r border-[#2A2D31] disabled:opacity-50">+10</button>
                        <button onClick={() => multiplyBet(0.5)} disabled={inputsLocked} className="px-3 text-xs font-bold text-zinc-400 hover:text-white hover:bg-[#33363b] transition-colors border-r border-[#2A2D31] disabled:opacity-50">1/2</button>
                        <button onClick={() => multiplyBet(2)} disabled={inputsLocked} className="px-3 text-xs font-bold text-zinc-400 hover:text-white hover:bg-[#33363b] transition-colors disabled:opacity-50">2x</button>
                      </div>
                    </div>
                  </div>

                  {/* ===== AUTO MOD KONTROLLERİ ===== */}
                  {mode === 'auto' && (
                    <>
                      {/* BAHİS SAYISI */}
                      <div>
                        <label className="text-xs text-zinc-400 font-bold mb-1.5 block">Number of Bets</label>
                        <div className="flex bg-[#15171a] border border-[#2A2D31] rounded-xl overflow-hidden focus-within:border-[#B059E8] transition-colors">
                          <input
                            type="text"
                            inputMode="numeric"
                            value={numberOfBets}
                            onChange={(e) => handleDigitsOnly(setNumberOfBets)(e.target.value)}
                            disabled={autoRunning}
                            placeholder="∞"
                            className="w-full bg-transparent py-3 px-4 text-white font-bold outline-none disabled:opacity-50 placeholder:text-zinc-600"
                          />
                          <button
                            onClick={() => setNumberOfBets('')}
                            disabled={autoRunning}
                            title="Infinite"
                            className="px-4 flex items-center justify-center text-zinc-400 border-l border-[#2A2D31] hover:text-[#B059E8] transition-colors disabled:opacity-50"
                          >
                            <InfinityIcon className="w-4 h-4" />
                          </button>
                        </div>
                      </div>

                      {/* ON WIN */}
                      <div>
                        <label className="text-xs text-zinc-400 font-bold mb-1.5 block">On Win</label>
                        <div className="flex gap-2">
                          <div className="flex flex-1 bg-[#15171a] border border-[#2A2D31] rounded-xl p-1 gap-1">
                            <button
                              onClick={() => setOnWinAction('reset')}
                              disabled={autoRunning}
                              className={`flex-1 py-2 rounded-lg text-xs font-bold transition-all ${onWinAction === 'reset' ? 'bg-[#16A34A] text-white shadow-[0_0_12px_rgba(22,163,74,0.3)]' : 'text-zinc-400 hover:text-white disabled:opacity-50'}`}
                            >Reset</button>
                            <button
                              onClick={() => setOnWinAction('increase')}
                              disabled={autoRunning}
                              className={`flex-1 py-2 rounded-lg text-xs font-bold transition-all ${onWinAction === 'increase' ? 'bg-[#B059E8] text-white shadow-[0_0_12px_rgba(176,89,232,0.3)]' : 'text-zinc-400 hover:text-white disabled:opacity-50'}`}
                            >Increase</button>
                          </div>
                          <div className={`flex items-center bg-[#15171a] border border-[#2A2D31] rounded-xl w-[88px] transition-all ${onWinAction === 'increase' ? 'focus-within:border-[#B059E8]' : 'opacity-50'}`}>
                            <input
                              type="text"
                              inputMode="decimal"
                              value={onWinPct}
                              onChange={(e) => handleDecimal(setOnWinPct)(e.target.value)}
                              disabled={autoRunning || onWinAction !== 'increase'}
                              placeholder="0"
                              className="w-full bg-transparent py-2.5 px-3 text-white font-bold outline-none text-right disabled:cursor-not-allowed"
                            />
                            <span className="text-zinc-500 font-bold pr-3 text-sm">%</span>
                          </div>
                        </div>
                      </div>

                      {/* ON LOSS */}
                      <div>
                        <label className="text-xs text-zinc-400 font-bold mb-1.5 block">On Loss</label>
                        <div className="flex gap-2">
                          <div className="flex flex-1 bg-[#15171a] border border-[#2A2D31] rounded-xl p-1 gap-1">
                            <button
                              onClick={() => setOnLossAction('reset')}
                              disabled={autoRunning}
                              className={`flex-1 py-2 rounded-lg text-xs font-bold transition-all ${onLossAction === 'reset' ? 'bg-[#16A34A] text-white shadow-[0_0_12px_rgba(22,163,74,0.3)]' : 'text-zinc-400 hover:text-white disabled:opacity-50'}`}
                            >Reset</button>
                            <button
                              onClick={() => setOnLossAction('increase')}
                              disabled={autoRunning}
                              className={`flex-1 py-2 rounded-lg text-xs font-bold transition-all ${onLossAction === 'increase' ? 'bg-[#B059E8] text-white shadow-[0_0_12px_rgba(176,89,232,0.3)]' : 'text-zinc-400 hover:text-white disabled:opacity-50'}`}
                            >Increase</button>
                          </div>
                          <div className={`flex items-center bg-[#15171a] border border-[#2A2D31] rounded-xl w-[88px] transition-all ${onLossAction === 'increase' ? 'focus-within:border-[#B059E8]' : 'opacity-50'}`}>
                            <input
                              type="text"
                              inputMode="decimal"
                              value={onLossPct}
                              onChange={(e) => handleDecimal(setOnLossPct)(e.target.value)}
                              disabled={autoRunning || onLossAction !== 'increase'}
                              placeholder="0"
                              className="w-full bg-transparent py-2.5 px-3 text-white font-bold outline-none text-right disabled:cursor-not-allowed"
                            />
                            <span className="text-zinc-500 font-bold pr-3 text-sm">%</span>
                          </div>
                        </div>
                      </div>

                      {/* STOP ON PROFIT / LOSS */}
                      <div className="grid grid-cols-2 gap-3">
                        <div>
                          <label className="text-[11px] text-zinc-400 font-bold mb-1.5 block">Stop on Profit</label>
                          <div className="flex bg-[#15171a] border border-[#2A2D31] rounded-xl overflow-hidden focus-within:border-[#16A34A] transition-colors">
                            <div className="pl-2.5 flex items-center"><span className="text-zinc-500 font-bold text-sm">$</span></div>
                            <input
                              type="text"
                              value={stopOnProfit}
                              onChange={(e) => setStopOnProfit(e.target.value)}
                              disabled={autoRunning}
                              placeholder="0"
                              className="w-full bg-transparent py-2.5 px-1.5 text-white font-bold outline-none text-sm disabled:opacity-50 placeholder:text-zinc-600 uppercase"
                            />
                          </div>
                        </div>
                        <div>
                          <label className="text-[11px] text-zinc-400 font-bold mb-1.5 block">Stop on Loss</label>
                          <div className="flex bg-[#15171a] border border-[#2A2D31] rounded-xl overflow-hidden focus-within:border-rose-500 transition-colors">
                            <div className="pl-2.5 flex items-center"><span className="text-zinc-500 font-bold text-sm">$</span></div>
                            <input
                              type="text"
                              value={stopOnLoss}
                              onChange={(e) => setStopOnLoss(e.target.value)}
                              disabled={autoRunning}
                              placeholder="0"
                              className="w-full bg-transparent py-2.5 px-1.5 text-white font-bold outline-none text-sm disabled:opacity-50 placeholder:text-zinc-600 uppercase"
                            />
                          </div>
                        </div>
                      </div>

                      {/* SEÇİM İPUCU */}
                      <div className="flex items-start gap-2 bg-[#B059E8]/10 border border-[#B059E8]/20 rounded-xl px-3 py-2.5">
                        <Info className="w-4 h-4 text-[#B059E8] flex-shrink-0 mt-0.5" />
                        <span className="text-[11px] text-zinc-400 leading-snug">
                          {autoTiles.length > 0
                            ? <><span className="text-[#cd9cf0] font-bold">{autoTiles.length} tile{autoTiles.length > 1 ? 's' : ''}</span> selected. Tap a tile again to remove it.</>
                            : <>Tap tiles on the grid to set your <span className="text-[#cd9cf0] font-bold">auto-pick pattern</span>.</>}
                        </span>
                      </div>
                    </>
                  )}
                </div>

                {/* AKSİYON BUTONU */}
                <div className="mt-auto pt-4">
                  {mode === 'auto' ? (
                    autoRunning ? (
                      <button
                        onClick={stopAutoBet}
                        className="w-full py-4 rounded-xl font-heading font-bold text-lg uppercase tracking-wider transition-all shadow-lg bg-gradient-to-r from-[#e11d48] to-[#f43f5e] hover:from-[#f43f5e] hover:to-[#fb7185] text-white flex items-center justify-center gap-2"
                      >
                        <span className="relative flex h-2.5 w-2.5">
                          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
                          <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-white"></span>
                        </span>
                        Stop Autobet
                      </button>
                    ) : (
                      <button
                        onClick={startAutoBet}
                        disabled={!betAmount || autoTiles.length === 0}
                        className="w-full py-4 rounded-xl font-heading font-bold text-lg uppercase tracking-wider transition-all shadow-lg bg-gradient-to-r from-[#7b2fc4] to-[#B059E8] hover:from-[#B059E8] hover:to-[#c98bf0] text-white disabled:opacity-50 disabled:grayscale"
                      >
                        Start Autobet
                      </button>
                    )
                  ) : (
                    phase === 'idle' || phase === 'crashed' || phase === 'cashed_out' ? (
                      <button
                        onClick={startGame}
                        disabled={!betAmount}
                        className="w-full py-4 rounded-xl font-heading font-bold text-lg uppercase tracking-wider transition-all shadow-lg bg-gradient-to-r from-[#7b2fc4] to-[#B059E8] hover:from-[#B059E8] hover:to-[#c98bf0] text-white disabled:opacity-50 disabled:grayscale"
                      >
                        {phase === 'crashed' || phase === 'cashed_out' ? 'Play Again' : 'Bet'}
                      </button>
                    ) : (
                      <button
                        onClick={handleCashout}
                        disabled={currentMultiplier <= 1.00}
                        className="w-full py-4 rounded-xl font-heading font-bold text-lg uppercase tracking-wider transition-all shadow-lg bg-gradient-to-r from-[#16A34A] to-[#2ecf6e] hover:from-[#2ecf6e] hover:to-[#5ee08f] text-white disabled:opacity-50 disabled:grayscale flex flex-col items-center justify-center leading-none"
                      >
                        <span className="mb-1">CASHOUT</span>
                        {currentMultiplier > 1.00 && (
                          <span className="text-sm opacity-90 mm-num">
                            <WalletValue amount={Math.floor(betToRaw(parseAmount(betAmount)) * currentMultiplier)} wallet={wallet} />
                          </span>
                        )}
                      </button>
                    )
                  )}
                </div>
              </div>
            </div>

            {/* SAĞ SÜTUN: OYUN TAHTASI */}
            <div className="flex-1 flex flex-col items-center justify-center bg-[#1A1D20] rounded-2xl border border-[#2A2D31] shadow-2xl relative overflow-hidden h-full p-4 lg:p-6 min-h-[520px]">

              <div className="absolute top-4 left-4 md:top-6 md:left-6 flex flex-col z-10">
                <span className="text-zinc-500 text-xs md:text-sm font-bold uppercase tracking-widest mb-0.5">Current Multiplier</span>
                <span className={`text-3xl md:text-4xl font-heading font-bold ${multiplierColor} drop-shadow-lg transition-colors`}>
                  {currentMultiplier.toFixed(2)}x
                </span>
                {phase === 'playing' && nextMultiplier && (
                  <span className="text-zinc-400 mm-num text-[10px] md:text-xs mt-1">Next: <span className="text-white font-bold">{nextMultiplier.toFixed(2)}x</span></span>
                )}
              </div>

              {/* AUTO İSTATİSTİK PANELİ */}
              {mode === 'auto' && (autoRunning || autoStats.bets > 0) && (
                <div className="absolute top-4 right-4 md:top-6 md:right-6 flex gap-2 z-10">
                  <div className="bg-[#15171a]/80 backdrop-blur border border-[#2A2D31] rounded-xl px-3 py-2 flex flex-col items-end">
                    <span className="text-[10px] text-zinc-500 font-bold uppercase tracking-wider">Bets</span>
                    <span className="text-sm md:text-base font-bold text-white mm-num">{autoStats.bets}</span>
                  </div>
                  <div className="bg-[#15171a]/80 backdrop-blur border border-[#2A2D31] rounded-xl px-3 py-2 flex flex-col items-end">
                    <span className="text-[10px] text-zinc-500 font-bold uppercase tracking-wider">Profit</span>
                    <span className={`text-sm md:text-base font-bold mm-num ${autoStats.profit >= 0 ? 'text-[#2ecf6e]' : 'text-rose-500'}`}>
                      {autoStats.profit >= 0 ? '+' : '-'}<WalletValue amount={Math.abs(autoStats.profit)} wallet={wallet} />
                    </span>
                  </div>
                </div>
              )}

              {/* 5x5 MINES GRID */}
              <div className="w-full max-w-[320px] md:max-w-[420px] grid grid-cols-5 gap-2 md:gap-3 mt-28 md:mt-12 mb-12 z-0 relative">
                {board.map((tile, idx) => {
                  const isSelected = mode === 'auto' && !tile.revealed && autoTiles.includes(idx);
                  const pickOrder = isSelected ? autoTiles.indexOf(idx) + 1 : null;
                  const clickable = mode === 'auto' ? !autoRunning : (phase === 'playing' && !tile.revealed);
                  return (
                    <motion.button
                      key={idx}
                      onClick={() => onTileClick(idx)}
                      disabled={!clickable}
                      whileHover={clickable ? HOVER_SCALE : EMPTY_ANIM}
                      whileTap={clickable ? TAP_SCALE : EMPTY_ANIM}
                      /* ⚡ transition-all → transition-colors */
                      className={`aspect-square rounded-xl border-2 flex items-center justify-center transition-colors duration-300 relative overflow-hidden ${getTileStyle(tile, idx)}`}
                    >
                      {/* AUTO SEÇİM İŞARETİ */}
                      {isSelected && (
                        <motion.span
                          initial={{ scale: 0 }}
                          animate={{ scale: 1 }}
                          className="w-6 h-6 md:w-7 md:h-7 rounded-full bg-[#B059E8] text-white text-xs font-bold flex items-center justify-center shadow-[0_0_10px_rgba(176,89,232,0.6)]"
                        >
                          {pickOrder}
                        </motion.span>
                      )}

                      <AnimatePresence>
                        {tile.revealed && (
                          <motion.div
                            /* ⚡ rotate KALDIRILDI: patlamada 25 kutu aynı anda
                               dönüyordu. Ölçek aynı hissi veriyor, maliyeti düşük. */
                            initial={{ scale: 0 }}
                            animate={{ scale: 1 }}
                            transition={{ duration: 0.18, ease: 'easeOut' }}
                            className="z-10 flex items-center justify-center w-full h-full"
                          >
                            {tile.type === 'bomb' ? (
                              <img src="/coin.png" alt="Bomb" className={`w-3/5 h-3/5 object-contain ${!tile.isPlayerChoice && 'grayscale opacity-70'}`} />
                            ) : (
                              <img src="/logo.png" alt="Gem" className={`w-3/5 h-3/5 object-contain drop-shadow-[0_0_10px_rgba(22,163,74,0.5)] ${!tile.isPlayerChoice && 'grayscale opacity-70'}`} />
                            )}
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </motion.button>
                  );
                })}
              </div>

              {/* MANUEL SONUÇ BANNERLARI (auto modda gösterilmez) */}
              {mode === 'manual' && phase === 'crashed' && (
                <motion.div initial={{ y: 20, opacity: 0 }} animate={{ y: 0, opacity: 1 }} className="absolute bottom-12 md:bottom-16 bg-rose-500 text-white px-6 md:px-8 py-2 md:py-3 rounded-full font-bold text-base md:text-lg shadow-[0_0_30px_rgba(244,63,94,0.5)] z-20">
                  Crashed!
                </motion.div>
              )}
              {mode === 'manual' && phase === 'cashed_out' && (
                <motion.div initial={{ y: 20, opacity: 0 }} animate={{ y: 0, opacity: 1 }} className="absolute bottom-12 md:bottom-16 bg-[#16A34A] text-white px-6 md:px-8 py-2 md:py-3 rounded-full font-bold text-base md:text-lg shadow-[0_0_30px_rgba(22,163,74,0.5)] flex items-center gap-2 z-20">
                  <ArrowUpFromLine className="w-4 h-4 md:w-5 md:h-5" />
                  Won <WalletValue amount={winAmount} wallet={wallet} />!
                </motion.div>
              )}

              {/* AUTO MOD: ÇALIŞIYOR / SON SONUÇ ROZETİ */}
              {mode === 'auto' && autoRunning && (
                <motion.div initial={{ y: 20, opacity: 0 }} animate={{ y: 0, opacity: 1 }} className="absolute bottom-12 md:bottom-16 bg-[#15171a] border border-[#B059E8]/40 text-white px-5 md:px-7 py-2 md:py-2.5 rounded-full font-bold text-sm md:text-base shadow-[0_0_30px_rgba(176,89,232,0.25)] flex items-center gap-2.5 z-20">
                  <span className="relative flex h-2.5 w-2.5">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#B059E8] opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#B059E8]"></span>
                  </span>
                  Autobet running…
                </motion.div>
              )}

              <div className="absolute bottom-4 left-4 right-4 flex flex-col md:flex-row items-center justify-between gap-2 text-[10px] md:text-xs text-zinc-500 mm-num pointer-events-none px-2">
                <div className="flex items-center gap-1.5">
                  <ShieldCheck className="w-4 h-4 text-[#16A34A]" />
                  <span>Provably Fair</span>
                </div>
                {serverHash && (
                  <div className="flex gap-4 w-full md:w-auto overflow-hidden opacity-70">
                    <span className="truncate" title={serverHash}>
                      <span className="text-zinc-600">Hash:</span> {serverHash.substring(0, 16)}...
                    </span>
                    {serverSeed && (
                      <span className="truncate text-[#16A34A]" title={serverSeed}>
                        <span className="text-[#15913f]">Seed:</span> {serverSeed.substring(0, 16)}...
                      </span>
                    )}
                  </div>
                )}
              </div>

            </div>
          </main>
        </div>
      </div>
    </div>
  );
};